import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=c857be74&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=c857be74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c857be74",
  null
  
)

export default component.exports